export const BACKGROUND_OPTIONS = {
  GRADIENT: 'Gradient',
  IMAGE: 'Image',
  SOLID_COLOR: 'Solid Color',
}

export const BACKGROUND_DROPDOWN_OPTIONS = [
  { value: BACKGROUND_OPTIONS.GRADIENT, label: BACKGROUND_OPTIONS.GRADIENT },
  {
    value: BACKGROUND_OPTIONS.SOLID_COLOR,
    label: BACKGROUND_OPTIONS.SOLID_COLOR,
  },
]

export const BrandingOptions = {
  LOGO: 'LOGO',
  NONE: 'NONE',
  CUSTOM: 'CUSTOM',
  ABSOLUTELY_NO_BRANDING: 'ABSOLUTELY_NO_BRANDING',
}

export const ContentOptions = {
  NONE: 'NONE',
  CONTENT: 'CONTENT',
  EMBED: 'EMBED',
}

export const BRANDING_MAP = [
  {
    option: BrandingOptions.ABSOLUTELY_NO_BRANDING,
    label: 'None',
  },
  {
    option: BrandingOptions.LOGO,
    label: 'Company logo',
  },
  {
    option: BrandingOptions.NONE,
    label: 'Company name',
  },
  {
    option: BrandingOptions.CUSTOM,
    label: 'Upload a custom logo',
  },
]

export const Statuses = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
}

export const COLOR_MODES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
}

// these labels were switched for a more intuitive UX, light mode now means light widget coloring
export const COLOR_MODE_COLORS = {
  [COLOR_MODES.LIGHT]: '#687882',
  [COLOR_MODES.DARK]: '#FFFFFF',
}

export const COLOR_MODE_DROPDOWN_OPTIONS = [
  { value: COLOR_MODES.DARK, label: 'Light' },
  { value: COLOR_MODES.LIGHT, label: 'Dark' },
]

export const SETTINGS_KEYS = {
  STYLES: 'Styles',
  CONTENT: 'Content',
}

export const UNIT_OPTIONS = {
  PERCENT: '%',
  PIXELS: 'px',
}

export const META_TAGS = {
  EMBEDDED_ONLY_PLAYBOOK: 'isEmbeddedOnly',
}

export const DomainTypes = {
  DRIFT_CLICK: 'DRIFT_CLICK',
  CNAME: 'CNAME',
}
